// extracted by mini-css-extract-plugin
export default {"container":"viewEquipment_container__z9W2H","content":"viewEquipment_content__-Y2KE"};